<div *ngIf="warnings?.length" class="alert-warning p-3 rounded">
  <ul>
    <li *ngFor="let warning of warnings">{{warning}}</li>
  </ul>
</div>
